





















import Vue, { PropType } from "vue";
import {
  HealthWorkout,
  formatNumber,
  formatWorkoutActivity,
  formatWorkoutDate,
  formatWorkoutDuration
} from "../healthPagePresentation";

export default Vue.extend({
  name: "HealthWorkoutCard",
  props: { workout: { type: Object as PropType<HealthWorkout>, required: true } },
  methods: { formatNumber, formatWorkoutActivity, formatWorkoutDate, formatWorkoutDuration }
});
